<script>
    import External from "./External.svelte";
</script>

<External url={"/worker.svg"} width={156.77} height={156.77}/>